import { ArrowDown, MoveDown, MoveDownLeft } from 'lucide-react';
import React from 'react';
import { Modal, Button, Accordion, Table, Badge } from 'react-bootstrap';

const VisitSummaryModal = ({ show, onClose, selectedData, selectedDate, selectedVitals }) => {
  if (!selectedData && !selectedVitals) return null;
  console.log('d', selectedData.map(i => i.comment))
  console.log("selectedData",selectedData)

  console.log("selectedVitals",selectedVitals?.data);
  console.log('vitals-data', selectedVitals)

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Patient Visit Summary</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Appointment Details */}
        <div className={"divider divider-start fw-medium"}>
            <span>Visit Summary</span>
        </div>

        <div className='mb-2' style={{textTransform:'capitalize'}}><strong>Doctor:</strong> {selectedData[0]?.createdBy || "---"}</div>
        <div className='mb-4'><strong>Date:</strong> {selectedDate || "---"}</div>
     

        <Accordion defaultActiveKey="0">
          {/* Discussions Section */}
          <Accordion.Item eventKey="0">
            <Accordion.Header>
                <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                  {/* <i className="ri-information-line"></i> */}
                  <ArrowDown/>
                </div>
                &nbsp;
                Diagnosis
              </Accordion.Header>
            <Accordion.Body>
              {selectedData?.length > 0 ? (
                <Table striped  hover responsive>
                  <thead>
                    <tr>
                      <th>Consultant</th>
                      <th>Diagnosis</th>
                      <th>Comment</th>
                      <th>Reaction</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedData?.map((item, index) => (
                      <tr key={index}>
                        {/* <td>
                          <h6>{selectedDate}</h6>
                        </td> */}
                        <td>
                          <div className='d-flex align-items-center gap-2'>
                            <div className="avatar">
                              <span className="avatar-initial"><i class="ri-user-line"></i></span>
                            </div>
                            <div>
                              {item?.diagnosis?.createdBy && Array.isArray(item?.diagnosis?.createdBy) ? (
                                  item?.diagnosis?.createdBy.map((d, i) => (
                                    <h6 key={i}>{d}</h6>
                                  ))
                                ) : (
                                  <h6 className='text-capitalize'>Dr.{item?.diagnosis?.createdBy?? '---'}</h6>
                                )}
                            </div>
                          </div>
                        </td>
                        <td className=''>
                          <div className='mt-1'>
                            {item?.diagnosis?.description && Array.isArray(item?.diagnosis?.description) ? (
                                item?.diagnosis?.description.map((d, i) => (
                                  <h6 key={i}>{d}</h6>
                                ))
                              ) : (
                                <h6>{item?.diagnosis?.description?? '---'}</h6>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className='mt-1'>
                            {item?.comment && Array.isArray(item?.comment) ? (
                                item?.comment.map((d, i) => (
                                  <h6 key={i}>{d}</h6>
                                ))
                              ) : (
                                <h6>{item?.comment || '---'}</h6>
                              )}
                          </div>
                        </td>
                        <td>
                        {item?.reaction && Array.isArray(item?.reaction) ? (
                            item?.reaction.map((d, i) => (
                              <h6 key={i}>{d}</h6>
                            ))
                          ) : (
                            <h6>{item?.reaction || '---'}</h6>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
               ) : (
                <p className="text-muted">No diagnosis recorded.</p>
              )
              } 
            </Accordion.Body>
          </Accordion.Item>

          {/* Vitals */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>
            <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                    {/* <i className="ri-information-line"></i> */}
                    <ArrowDown/>
                  </div>
                  &nbsp;
                  Vitals</Accordion.Header>
            <Accordion.Body>
            {selectedData?.length > 0 ? (
                <Table striped  hover responsive>
                  {/* <thead>
                    <tr>
                      <th>Consultant</th>
                      <th>Blood Pressure</th>
                      <th>Pulse</th>
                      <th>Sp02</th>
                      <th>Temperature</th>
                      <th>Weight</th>
                    </tr>
                  </thead> */}
                  <tbody>
                    {selectedVitals[0]?.d?.map((item, index) => (
                      <tr key={index}>
                        {/* <td>
                          <h6>{selectedDate}</h6>
                        </td> */}
                         <td>
                          <div className='d-flex align-items-center gap-2'>
                            {/* <div className="avatar">
                              <span className="avatar-initial"><i class="ri-user-line"></i></span>
                            </div> */}
                            <ul className="list-unstyled">
        {Object.entries(item.reading || {}).map(([key, value], i) => (
          <li key={i} className="d-flex justify-content-between py-1 border-bottom">
            <strong className="text-capitalize">
              {key.replace(/_/g, ' ')}:
            </strong>
            <span>
              {key === 'blood_pressure' ? `${value} mm/Hg` :
               key === 'pulse' ? `${value} beats/min` :
               key === 'spo' ? `${value}%` :
               key === 'temperature' ? `${value}°` :
               key === 'weight' ? `${value} kg` :
               value}
            </span>
          </li>
        ))}
      </ul>
                          </div>
                        </td>
                       
                      
                        <td>
                        {/* {item?.reaction && Array.isArray(item.reaction) ? (
                            item.reaction.map((d, i) => (
                              <h6 key={i}>{d}</h6>
                            ))
                          ) : (
                            <h6>{item.reaction || '---'}</h6>
                          )} */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
               ) : (
                <p className="text-muted">No discussions recorded.</p>
              )
              } 
            </Accordion.Body>
          </Accordion.Item>

          {/* Conclusions Section */}
          {/* <Accordion.Item eventKey="2">
            <Accordion.Header>
            <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
            <ArrowDown/>
                  </div>
                  &nbsp;
                  Conclusions</Accordion.Header>
            <Accordion.Body>
              <p>{appointment.conclusion || <span className="text-muted">No conclusions provided.</span>}</p>
            </Accordion.Body>
          </Accordion.Item> */}
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VisitSummaryModal;